import { EUiStates } from "@constants/enum";
import { ReactElement } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button, ButtonToolbar } from "reactstrap";

const ButtonContainer = (): ReactElement => {
  const { pathname } = useLocation();
  const isDetail = pathname.includes("/detail") ?? false;

  let buttonText = "Modify";
  let icon = "lnr lnr-pencil";
  let buttonColor = EUiStates.WARNING;

  if (pathname.includes("/create")) {
    buttonText = "Create";
    icon = "lnr lnr-plus-circle";
    buttonColor = EUiStates.SUCCESS;
  }

  return (
    <ButtonToolbar className="form__button-toolbar">
      <Link to={`${pathname.substring(0, pathname.lastIndexOf("/list"))}/list`}>
        <Button type="button">
          <span className="lnr lnr-chevron-left" />
          Go Back
        </Button>
      </Link>

      {isDetail ? (
        <Link to={pathname.replace("detail", "modify")}>
          <Button color={buttonColor} type="submit">
            <span className="lnr lnr-pencil" /> {buttonText}
          </Button>
        </Link>
      ) : (
        <Button color={buttonColor} type="submit">
          <span className={icon} /> {buttonText}
        </Button>
      )}
    </ButtonToolbar>
  );
};

export default ButtonContainer;
